import mixpanel from 'mixpanel-browser';

class Mixpanel {
    constructor() {
        // Skip init when MIXPANEL_TOKEN is unset (e.g. CI smoke builds without analytics
        // secrets). mixpanel-browser throws on undefined; that would prevent React mount.
        this.enabled = !!process.env.MIXPANEL_TOKEN;
        if (this.enabled) {
            mixpanel.init(process.env.MIXPANEL_TOKEN, { opt_out_tracking_by_default: true });
            this.lib = mixpanel;
        } else {
            // No-op shim so callers can still reference Mixpanel.lib.* without crashing.
            this.lib = new Proxy({}, { get: () => () => undefined });
        }
    }

    identify(user) {
        if (!this.enabled) {
            return;
        }
        if (user && user.accepted_cookies && user.accepted_cookies === true) {
            if (mixpanel.has_opted_out_tracking()) {
                mixpanel.opt_in_tracking();
            }
            mixpanel.identify(user.id);
        }
    }
}

export default new Mixpanel();
